<template>
  <div class="modal counter-offer-modal">
    <div class="overlay" @click="$parent.closeCounterOfferModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeCounterOfferModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">COUNTER OFFER</div>

                <div class="offer-items">
                  <div class="offer-items-header">
                    <span class="col-name">Item</span>
                    <span class="col-qty">Qty</span>
                  </div>
                  <div
                    class="offer-item-row"
                    v-for="(item, i) in $parent.counterOfferRequest.items"
                    :key="i"
                  >
                    <span class="col-name">{{ item.short_name }}</span>
                    <span class="col-qty">x{{ item.quantity }}</span>
                  </div>
                </div>

                <div class="offer-summary">
                  <div class="summary-row">
                    <span class="summary-label">Your price:</span>
                    <span class="summary-value your-price">
                      {{ $parent.counterOfferRequest.total_amount }}
                      <img src="./../img/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                  <div class="summary-row highlight">
                    <span class="summary-label">Admin offer:</span>
                    <span class="summary-value offer">
                      {{ $parent.counterOfferRequest.counter_offer_amount }}
                      <img src="./../img/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                </div>

                <div class="counter-offer-note">
                  By accepting, your items will be removed from the game and the offered amount will be credited to your payout balance.
                </div>

                <transition name="slide">
                  <div v-if="$parent.counterOfferError" class="error-desc desc red">
                    {{ $parent.counterOfferError }}
                  </div>
                </transition>

                <div class="counter-offer-buttons">
                  <button
                    class="button button-accept"
                    @click="$parent.approveCounterOffer"
                    :disabled="$parent.sellRequestActionLoading"
                  >
                    {{ $parent.sellRequestActionLoading ? 'PROCESSING...' : 'ACCEPT' }}
                  </button>
                  <button
                    class="button button-decline"
                    @click="$parent.declineCounterOffer($parent.counterOfferRequest.id)"
                    :disabled="$parent.sellRequestActionLoading"
                  >DECLINE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CounterOfferModal",
};
</script>
